import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteCompanyPayload } from '@app-store/slices/companies/delete'

interface TaskAction extends Action {
    payload: IDeleteCompanyPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.companies.delete

function* deleteCompanySagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/companies/${payload.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Company deleted successfully.'
            })
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteCompanySaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteCompanySagaTask)
}

export default deleteCompanySaga
